import { render } from "./PabloQuacious.vue?vue&type=template&id=7864c3b4&scoped=true"
import script from "./PabloQuacious.vue?vue&type=script&lang=js"
export * from "./PabloQuacious.vue?vue&type=script&lang=js"

import "./PabloQuacious.vue?vue&type=style&index=0&id=7864c3b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7864c3b4"]])

export default __exports__